import {http, onSuccess, onFail} from './http';

export const getEpisodePartners = (episode) => {
    return http.get(`/api/cp/event/stream/episode/${episode}/partner`)
        .then(onSuccess, onFail);
};

export const createEpisodePartner = (episode, payload) => {
    return http.post(`/api/cp/event/stream/episode/${episode}/partner`, payload)
        .then(onSuccess, onFail);
};

export const updateEpisodePartner = (episodePartner, payload) => {
    return http.post(`/api/cp/event/stream/episode/partner/${episodePartner}`, payload)
        .then(onSuccess, onFail);
};

export const removeEpisodePartner = (episodePartner) => {
    return http.delete(`/api/cp/event/stream/episode/partner/${episodePartner}`)
        .then(onSuccess, onFail);
};

export const updateEpisodePartnersOrder = (episode, payload) => {
    return http.post(`/api/cp/event/stream/episode/${episode}/partner-order`, {sortPartners: payload})
        .then(onSuccess, onFail);
};
